import { render } from "./TrafficReport.vue?vue&type=template&id=4d327d7a"
import script from "./TrafficReport.vue?vue&type=script&lang=js"
export * from "./TrafficReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__